<template>
  <div class="transition">
    <v-card class="p-5" shaped elevation="10">
      <div class="flex justify-center w-full" v-if="loading">
        <Lynx-Spinner size="12" />
      </div>
      <div v-else class="w-full">
        <div class="w-full flex justify-between items-center grid-cols-3">
        <h2 class="text-lg md:text-base text-neutral-600">
          {{ header.title }}
        </h2>
        <label class="flex flex-col w-2/5 pb-6 pr-5 items-end">
          <v-row>
            <p class="pt-4 pr-1" style="font-size: 20px">%</p>
            <b-switch v-model="isValor" outlined> Qtd </b-switch>
          </v-row>
        </label>
      </div>
        <div class="pt-2 w-full">
          <EmpresaCarteiraChart :isValor="isValor" :values="dataSet" :label="label" />
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import EmpresaCarteiraChart from "@/views/charts/empresas/EmpresaCarteiraChart";
import { companiesCarteiraRequest } from "@/services/requests/charts";

export default {
  name: "EmpresaStatus",
  components: { EmpresaCarteiraChart },
  data() {
    return {
      header: {
        title: "Empresa Por Carteira",
        icon: "Document",
      },
      loading: true,
      dataSet: [],
      label: [],
      isValor:true
    };
  },
  methods: {
    fetchResults() {
      this.loading = true;
      companiesCarteiraRequest()
        .then((res) => {
          console.log(res.data);
          this.dataSet = res.data.datasets;
          this.label = res.data.label;
        })
        .finally(() => (this.loading = false));
    },
  },
  beforeMount() {
    this.fetchResults();
  },
};
</script>
